// Services/fetchCourierMyOrders.js
import { ApiRequestInterceptor } from "./apiRequest";
import { REPARTIDORES } from "../Constants/Endpoints";

// GET /courier/my-orders  (admin puede pasar ?userId=USR#...)
export const fetchCourierMyOrders = async (opts = {}) => {
    const method = "GET";

    // Evita doble slash si en la constante viene con "/"
    let base = `${REPARTIDORES.viewOrders}`;
    if (base.startsWith("/")) base = base.slice(1);

    // Query params (solo usa userId si lo mandan; para repartidor normal no hace falta)
    const params = new URLSearchParams();
    if (opts.userId) params.set("userId", opts.userId);

    const url = params.toString() ? `${base}?${params.toString()}` : base;

    const response = await ApiRequestInterceptor(url, method);

    // Normaliza la respuesta
    const parsed =
        typeof response?.body === "string"
            ? JSON.parse(response.body)
            : (response?.body ?? response?.data ?? response);

    const items =
        parsed?.items ??
        parsed?.orders ??
        parsed?.data?.items ??
        [];

    const count = parsed?.count ?? items.length;

    return {
        statusCode: response?.statusCode ?? response?.code ?? 200,
        items,
        count,
        body: parsed,   // por si quieres inspeccionar más campos
    };
};